module.exports = __webpack_public_path__ + "img/public/SiteIcons/instagramIcon.svg?8276f598";